export default {
  getUserTarget: (state) => state.userTarget,
};
